const EMPTY_NAME_VALUES = ['undefined', 'null', 'false'];

export const cleanNamePart = value => {
    if (value === undefined || value === null) return '';

    const text = String(value).trim();
    if (EMPTY_NAME_VALUES.includes(text.toLowerCase())) return '';

    return text;
}

export const firstNonEmptyNamePart = (...values) =>
    values.map(cleanNamePart).find(Boolean) || '';

export const joinNameParts = (...parts) =>
    parts.map(cleanNamePart).filter(Boolean).join(' ');

export const getCastellerFirstSurname = casteller =>
    firstNonEmptyNamePart(
        casteller?.['primer-cognom'],
        casteller?.primer_cognom,
        casteller?.primerCognom,
        casteller?.cognom
    );

export const getCastellerSecondSurname = casteller =>
    firstNonEmptyNamePart(
        casteller?.['segon-cognom'],
        casteller?.segon_cognom,
        casteller?.segonCognom
    );

export const getCastellerFullName = (casteller, fallback = 'Anònim', options = {}) => {
    const { includeSecondSurname = false } = options;
    const fullName = joinNameParts(
        casteller?.nom,
        getCastellerFirstSurname(casteller),
        includeSecondSurname ? getCastellerSecondSurname(casteller) : ''
    );

    return fullName || cleanNamePart(fallback);
}

export const getCastellerDisplayName = (casteller, fallback = 'Anònim') =>
    cleanNamePart(casteller?.mote) || getCastellerFullName(casteller, fallback);

export const getCastellerNameWithMote = (casteller, fallback = 'Anònim', options = {}) => {
    const fullName = getCastellerFullName(casteller, '', options);
    const mote = cleanNamePart(casteller?.mote);

    if (fullName && mote) return `${fullName} (${mote})`;

    return mote || fullName || cleanNamePart(fallback);
}

export const getCastellerShortName = (casteller, fallback = 'Anònim') => {
    const mote = cleanNamePart(casteller?.mote);
    if (mote) return mote;

    const nom = cleanNamePart(casteller?.nom);
    const cognom = getCastellerFirstSurname(casteller);
    const cognomInitial = cognom ? `${cognom[0]}.` : '';
    const shortName = joinNameParts(nom, cognomInitial);

    return shortName || cleanNamePart(fallback);
}

export const getCastellerSearchText = casteller =>
    joinNameParts(
        casteller?.mote,
        casteller?.nom,
        getCastellerFirstSurname(casteller),
        getCastellerSecondSurname(casteller)
    );
